import { render, staticRenderFns } from "./carregarcomprovativo.vue?vue&type=template&id=4e52433f&"
import script from "./carregarcomprovativo.vue?vue&type=script&lang=js&"
export * from "./carregarcomprovativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports